import React from 'react';
import { useDispatch } from 'react-redux';
import { Button } from '@mui/material';

import { Icon, showConfirmCancelDialog, useSettings, Utils } from 'app/main/components';
import { DetailsSectionWrapper } from 'app/main/components/page-layouts';

interface MarketingActionsDetailsSectionDeleteRowsProps {
	maacUid: string;
	table: string;
	isLoading: boolean;
	updateRefresh: VoidFunction;
}

export default function MarketingActionsDetailsSectionDeleteRows(props: MarketingActionsDetailsSectionDeleteRowsProps) {
	const dispatch = useDispatch();
	const { t } = useSettings();

	const confirmSelection = () => {
		dispatch(
			showConfirmCancelDialog({
				title: t('DIALOG_EMPTY_LIST'),
				onConfirm: () =>
					Utils.executeStored({
						action: `st_marketingactions_rows_delete`,
						dispatch,
						data: { marw_maac_uid: props.maacUid, table: props.table },
						successHandler: () => {
							dispatch(Utils.alertSuccessMsg(t));
							props.updateRefresh();
						}
					})
			})
		);
	};

	return (
		<DetailsSectionWrapper
			title={t('MAAC_SECTION_EMPTY_TITLE')}
			actions={
				<Button startIcon={<Icon icon="delete" />} onClick={confirmSelection} disabled={props.isLoading}>
					{t('MAAC_SECTION_EMPTY_BUTTON_CLEAR')}
				</Button>
			}
		>
			{t('MAAC_SECTION_EMPTY_DESCRIPTION')}
		</DetailsSectionWrapper>
	);
}
